import { render, staticRenderFns } from "./guache.vue?vue&type=template&id=0258bc51&scoped=true&"
import script from "./guache.vue?vue&type=script&lang=js&"
export * from "./guache.vue?vue&type=script&lang=js&"
import style0 from "./guache.vue?vue&type=style&index=0&id=0258bc51&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0258bc51",
  null
  
)

export default component.exports